import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';
import { cn } from '@/utils/cn';

export interface BreadcrumbItem {
  label: string;
  path: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className }) => {
  return (
    <nav className={cn('flex items-center space-x-2 text-sm', className)}>
      {items.map((item, index) => (
        <div key={item.path} className="flex items-center space-x-2">
          {index > 0 && (
            <ChevronRightIcon className="w-4 h-4 text-gray-500 flex-shrink-0" />
          )}
          {index === 0 && (
            <HomeIcon className="w-4 h-4 text-gray-500 flex-shrink-0" />
          )}
          <Link
            to={item.path}
            className={cn(
              'hover:text-white transition-colors truncate',
              index === items.length - 1
                ? 'text-white font-medium'
                : 'text-gray-400'
            )}
          >
            {item.label}
          </Link>
        </div>
      ))}
    </nav>
  );
};
